import { Component } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

@Component({
  standalone: false,
  selector: 'gameday-direct-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  public readonly data: Data;

  constructor(private readonly route: ActivatedRoute) {
    this.data = this.route.snapshot.data;
  }
}
